export const FORM_KEYS = Object.freeze({
    NAME: "name",
    DETAILS: "details",
    DATE: "date",
    TIME_START: "timeStart",
    TIME_END: "timeEnd",
});
export const FORM_ERRORS_KEYS = Object.freeze({
    SCHEDULE: "schedule",
});
export const SCHEDULE_FIELDS_KEYS = [FORM_KEYS.TIME_START, FORM_KEYS.TIME_END];
export const INITIAL_FORM = {
    [FORM_KEYS.NAME]: "",
    [FORM_KEYS.DETAILS]: "",
    [FORM_KEYS.DATE]: -1,
    [FORM_KEYS.TIME_START]: -1,
    [FORM_KEYS.TIME_END]: -1
};
export const INITIAL_ERRORS = {
    [FORM_ERRORS_KEYS.SCHEDULE]: null
};
export const ERROR_TEXTS = {
    START_DATE_IS_GREATER_THAN_END_DATE: "La hora de inicio es mayor o igual a la de fin.",
    PAST_SCHEDULE: "El rango de horas es pasado.",
    CROSS_SCHEDULES: "Existe un cruce de horarios con las horas seleccionadas."
};